'use es6';
/*
 * State
 */

/*
{
  byId: {
    12345: {
      isActive: false,
      isValid: false,
      errorMessage: null,
      selections: {
       [widgetId]: {widgetId, rowId, parentId},
       [widgetId]: {widgetId, rowId, parentId},
       [widgetId]: {widgetId, rowId, parentId},
      },
    },
  },
}
*/

import { LAYOUT_GROUPING_TOGGLE, LAYOUT_GROUPING_TOGGLE_WIDGET, LAYOUT_GROUPING_VALIDATED, LAYOUT_GROUPING_CREATE, LAYOUT_GROUPING_REMOVE } from 'DesignData/actions/ActionTypes';
import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
/*
 * Reducers nested under byId
 */

const byIdReducers = combineReducers({
  /**
   * Is the grouping mode active in the layout editor.
   */
  isActive(state = false, action) {
    switch (action.type) {
      case LAYOUT_GROUPING_TOGGLE:
        {
          return !state;
        }

      case LAYOUT_GROUPING_CREATE:
        {
          return false;
        }

      default:
        return state;
    }
  },

  /**
   * Is the selected widgets valid to create a group.
   */
  isValid(state = false, action) {
    switch (action.type) {
      case LAYOUT_GROUPING_VALIDATED:
        {
          return action.validatedLayoutGroup.isValid;
        }

      case LAYOUT_GROUPING_CREATE:
      case LAYOUT_GROUPING_TOGGLE:
        {
          return false;
        }

      default:
        return state;
    }
  },

  /**
   * Error message if invalid.
   */
  errorMessage(state = null, action) {
    switch (action.type) {
      case LAYOUT_GROUPING_VALIDATED:
        {
          return action.validatedLayoutGroup.errorMessage || null;
        }

      case LAYOUT_GROUPING_CREATE:
      case LAYOUT_GROUPING_TOGGLE:
        {
          return null;
        }

      default:
        return state;
    }
  },

  /**
   * Matrix of all widgets/rows affected by grouping.
   */
  groupingMatrix(state = null, action) {
    switch (action.type) {
      case LAYOUT_GROUPING_VALIDATED:
        {
          return action.validatedLayoutGroup.groupingMatrix || null;
        }

      case LAYOUT_GROUPING_CREATE:
      case LAYOUT_GROUPING_TOGGLE:
        {
          return null;
        }

      default:
        return state;
    }
  },

  /**
   * The widgets selected in the grouping editor.
   */
  selections(state = SeamlessImmutable({}), action) {
    switch (action.type) {
      case LAYOUT_GROUPING_TOGGLE_WIDGET:
        {
          const {
            widgetId,
            rowId,
            parentId
          } = action;

          if (state[widgetId]) {
            return state.without(widgetId);
          }

          return state.set(widgetId, {
            widgetId,
            rowId,
            parentId
          });
        }

      case LAYOUT_GROUPING_CREATE:
      case LAYOUT_GROUPING_TOGGLE:
        {
          if (Object.keys(state).length) {
            return SeamlessImmutable({});
          }

          return state;
        }

      default:
        return state;
    }
  }

});

function byId(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case LAYOUT_GROUPING_TOGGLE:
    case LAYOUT_GROUPING_TOGGLE_WIDGET:
    case LAYOUT_GROUPING_CREATE:
    case LAYOUT_GROUPING_VALIDATED:
      {
        const {
          layoutId
        } = action;
        return state.set(layoutId, byIdReducers(state[layoutId], action));
      }

    case LAYOUT_GROUPING_REMOVE:
      {
        const {
          layoutId
        } = action;
        return state.without(layoutId);
      }

    default:
      {
        if (state.default) {
          return state;
        }

        return state.set('default', byIdReducers(state.default, action));
      }
  }
}

export default combineReducers({
  byId
});